import React, { FC, useState } from "react";
import { Grid, Link, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ImagesContext } from "../Context";
import { useHistory } from "react-router-dom";

interface Props {
  patient_id: string;
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  encounterId: string;
  setShowCreateFirstTemplate: (open: boolean) => void;
  setShowChooseClaimTemplate: (open: boolean) => void;
  claimTemplates: any[];
  setClaimTemplates: (templates: any[]) => void;
}

const ClaimTypeSelection: FC<Props> = (props: Props) => {
  const images = React.useContext(ImagesContext);
  const history = useHistory();

  const [claimType, setClaimType] = useState<string>("use_a_claim_template");

  const handleOptionSelection = () => {
    if (claimType === "create_claim_from_scratch") {
      history.push(
        `/patient_reports/${props.patient_id}/claims_builder?encounterBillingId=${props.encounterId}`
      );
    } else {
      if (props.claimTemplates.length === 0) {
        props.setModalOpen(false);
        props.setShowCreateFirstTemplate(true);
      } else {
        props.setModalOpen(false);
        props.setShowChooseClaimTemplate(true);
      }
    }
  };

  return (
    <Modal open={props.modalOpen} className="follow-up-modal">
      <div className="paper" style={{ width: "475px", padding: "0px" }}>
        <div className="paperInner" style={{ padding: "0px" }}>
          <Grid container className="fum-header-container">
            <Grid item xs={10}>
              <h1 className="fum-header">New Claim</h1>
            </Grid>
            <Grid
              item
              xs={2}
              className="fum-close-icon-container"
              style={{ paddingRight: "20px" }}
            >
              <Link
                onClick={() => props.setModalOpen(false)}
                style={{ color: "black" }}
              >
                <CloseIcon />
              </Link>
            </Grid>
          </Grid>
          <div className="divider-orange" style={{ margin: "0px" }}></div>

          <Grid item xs={12} style={{ textAlign: "center", padding: "25px" }}>
            Select an option below to proceed
          </Grid>

          <Grid container className="fum-form-container">
            <Grid item xs={12} className="q-selection-container">
              <div
                className={`q-selection-card ${
                  claimType == "use_a_claim_template" &&
                  "q-selection-card--active"
                }`}
                onClick={() => setClaimType("use_a_claim_template")}
              >
                <div>
                  <img
                    src={
                      claimType === "use_a_claim_template"
                        ? images.use_claim_template_white_icon
                        : images.use_claim_template_black_icon
                    }
                    alt="Use a claim template"
                    style={{ width: 35, maxHeight: 35 }}
                  />
                </div>
                <div>Use a claim template</div>
              </div>
              <div
                className={`q-selection-card ${
                  claimType == "create_claim_from_scratch" &&
                  "q-selection-card--active"
                }`}
                onClick={() => setClaimType("create_claim_from_scratch")}
              >
                <div>
                  <img
                    src={
                      claimType === "create_claim_from_scratch"
                        ? images.create_claim_from_scratch_white_icon
                        : images.create_claim_from_scratch_black_icon
                    }
                    alt="Create claim from scratch"
                    style={{ width: 35, maxHeight: 35 }}
                  />
                </div>
                <div>Create claim from scratch</div>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ padding: "30px" }}
          >
            <Grid
              item
              xs={4}
              className="cancel-link-container"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Link
                className="cancel-link"
                onClick={() => props.setModalOpen(false)}
              >
                Cancel
              </Link>
            </Grid>
            <Grid item xs={4} className="confirm-btn-container">
              <Link
                onClick={handleOptionSelection}
                className="confirm-btn"
                style={{ width: "135px" }}
              >
                Continue
              </Link>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default ClaimTypeSelection;
